export default class MongoNotificationProjectInvitation {
  projectId = "";
  projectTitle = "";
  invitorId = "";
  invitorName = "";
  invitorLogoUrl = "";
}
